import React, { memo } from 'react';
import CustomLink from '../../../../../CustomLink/CustomLink';
import classNames from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { pushToDataLayer } from '../../../../../../utils/pushToDataLayer/pushToDataLayer.util';
import { getQueryParam } from '../../../../../../utils/getQueryParam/getQueryParam.util';

interface ContactMethodFactoryProps {
  icon_url: string;
  url: string;
  label: string;
  openModal?: (state: boolean) => void;
  isModal?: boolean;
}

interface Content {
  icon_url: string;
  label: string;
}

const Content: React.FC<Content> = ({ icon_url, label }) => {
  return (
    <>
      <div className="flex items-center justify-start gap-x-4">
        <div
          className="w-10 h-10 rounded-full bg-no-repeat"
          style={{ background: `url(${icon_url})` }}
        ></div>
        <p className="text-text/body group-hover:text-system/white transition-all duration-300">
          {label}
        </p>
      </div>
      <div
        className="bg-no-repeat w-6 h-6 bg-text/body-accent group-hover:bg-system/white transition-all duration-300"
        style={{
          WebkitMaskImage: "url('/svgs/right-arrow.svg')",
          maskImage: "url('/svgs/right-arrow.svg')",
        }}
      />
    </>
  );
};

const ContactMethodFactory: React.FC<ContactMethodFactoryProps> = ({
  icon_url,
  url,
  label,
  openModal,
  isModal,
}) => {
  const md = useMediaQuery({
    query: '(max-width: 1023px)',
  });

  const containerClassName =
    'w-full flex items-center justify-between p-4 my-4 bg-stepper/stepper-bg hover:bg-stepper/stepper-active-bg rounded-[6px] transition-all duration-300 group cursor-pointer';

  const quoteReference = getQueryParam('quotation')?.substring(0, 7);
  const dataLayerLabel = label.includes('WhatsApp')
    ? 'whatsapp'
    : label.includes('Live Chat')
    ? 'live chat'
    : label.includes('Email')
    ? 'email'
    : label.includes('Call')
    ? 'phone'
    : label;

  if (isModal && openModal && !md) {
    return (
      <div
        className={classNames(containerClassName)}
        onClick={() => {
          openModal(true);
          pushToDataLayer({
            event: 'contact_quotation_advisor',
            data: {
              quote_reference_number: quoteReference,
              contact_method: dataLayerLabel,
            },
          });
        }}
      >
        <Content icon_url={icon_url} label={label}></Content>
      </div>
    );
  }
  return (
    <CustomLink
      url={url}
      label={label}
      className={classNames(containerClassName)}
    >
      <Content icon_url={icon_url} label={label}></Content>
    </CustomLink>
  );
};

export default memo(ContactMethodFactory);
